import { useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import DailyAdvice from './components/DailyAdvice';
import FepMethod from './components/FepMethod';
import AboutLeo from './components/AboutLeo';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  // Detectar scroll para el navbar
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#faf8f3]">
      {/* Navbar */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-white shadow-md'
            : 'bg-white/10 backdrop-blur-md'
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <div className="text-2xl font-bold text-[#1a2332]">
            SegurosconLeo
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-[#1a2332] hover:text-[#2d5a8f] transition-colors cursor-pointer whitespace-nowrap"
            >
              Inicio
            </button>
            <span className="text-gray-400">•</span>
            <button
              onClick={() => scrollToSection('metodo-fep')}
              className="text-[#1a2332] hover:text-[#2d5a8f] transition-colors cursor-pointer whitespace-nowrap"
            >
              Método FEP
            </button>
            <span className="text-gray-400">•</span>
            <button
              onClick={() => scrollToSection('sobre-mi')}
              className="text-[#1a2332] hover:text-[#2d5a8f] transition-colors cursor-pointer whitespace-nowrap"
            >
              Sobre Mí
            </button>
            <span className="text-gray-400">•</span>
            <button
              onClick={() => scrollToSection('testimonios')}
              className="text-[#1a2332] hover:text-[#2d5a8f] transition-colors cursor-pointer whitespace-nowrap"
            >
              Testimonios
            </button>
          </div>

          <a
            href="http://wa.me/524443289285"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#1a2332] text-white px-6 py-3 rounded-full hover:bg-[#2d5a8f] transition-all cursor-pointer whitespace-nowrap inline-block"
          >
            Agenda tu Consulta
          </a>
        </div>
      </nav>

      {/* Secciones */}
      <div id="hero">
        <Hero />
      </div>
      
      <DailyAdvice />
      
      <div id="metodo-fep">
        <FepMethod />
      </div>
      
      <div id="sobre-mi">
        <AboutLeo />
      </div>
      
      <div id="testimonios">
        <Testimonials />
      </div>
      
      <div id="contacto">
        <CtaSection />
      </div>
      
      <Footer />
    </div>
  );
}
